import { createAction } from '../helpers';

export const setAudienceFilter = createAction('SET_AUDIENCE_FILTER');
export const clearAudienceStore = createAction('CLEAR_AUDIENCE_STORE');
